<template>
	<div>

		<div class="app-download">
			<img src="@/assets/appH5/8f592cbf1f65bb7de963f4615ba3a96b.png" class="app-beijing">

			<div class="footer-btn" @click="downloadAPP()">点击下载App</div>
		</div>

		<div class="guide-bg" v-if="showWeixinTip" @click="showWeixinTip = false">
			<div class="arrow">
				<img src="@/assets/appH5/browser-tips.ee448999.png" class="arrowImg">
			</div>
		</div>

	</div>
</template>

<script>
import { Toast } from 'vant';
import wx from 'weixin-js-sdk'
export default {
	data() {
		return {
			platform: '', // 平台类型
			isAppInstalled: false,// 是否安装APP
			showWeixinTip: false //提示引导
		}
	},
	created() {
		var that = this;
		document.title = '下载学小成App';

		that.getConfig()

		//是否学习机
		// const brandMatch = false;
		// //检测学习机机型列表
		// const STUDY_DEVICE_KEYWORDS = [
		// 	'EduPad',       // 步步高
		// 	'ReadBoy',      // 读书郎
		// 	'XiaoYuan',     // 小猿
		// 	'iEnglish',     // 外研通
		// 	'Nabi',         // 美国孩之宝
		// 	'LeapFrog',     // 跳跳蛙
		// 	'/TB',          // 优学派
		// 	'iPhone',          // 优学派
		// 	'EduTab'        // 通用教育平板标识
		// ]
		// // 特征1：UA关键字匹配
		// STUDY_DEVICE_KEYWORDS.forEach(keyword => {
		// 	if (userAgent.includes(keyword)) {
		// 		brandMatch = true;
		// 		Toast(brandMatch);
		// 	}
		// })
		
		// 获取系统信息
		const userAgent = window.navigator.userAgent;
		//根据安卓、ios、其他设备获取最新app下载地址
		if (userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod') || userAgent.includes('Macintosh')) {
			that.platform = 'ios';
			//查询最新app下载地址
			that.getApp(that.platform)
		} else if (userAgent.includes('Android')) {
			that.platform = 'android';
			//查询最新app下载地址
			that.getApp(that.platform)
		} else {
			that.platform = 'android';
			// that.platform = 'none';
			//查询最新app下载地址
			that.getApp(that.platform)
		}
	},
	methods: {
		downloadAPP() {
			if (this.isWeixin()) {
				this.showWeixinTip = true;
				console.log('微信环境里', this.showWeixinTip)
				return;
			}

			//H5判断安卓或ios
			if (this.platform === 'ios') {
				console.log('ios')
				if (typeof plus !== 'undefined') {
					plus.runtime.openURL(this.downloadUrl, (err) => {
						if (err) {
							Toast('打开App Store失败');
						}
					});
				} else {
					// 如果不是在App环境，则使用浏览器打开App Store链接
					window.location.href = this.downloadUrl;
				}
			} else if (this.platform === 'android') {
				console.log('Android')
				if (typeof plus !== 'undefined') {
					plus.runtime.openURL(this.downloadUrl, (err) => {
						if (err) {
							Toast('打开下载链接失败');
						}
					});
				} else {
					// 如果不是在App环境，则使用浏览器打开下载链接
					window.location.href = this.downloadUrl;
				}

			} else {
				Toast('暂不支持该设备下载');
			}
		},

		getApp(type) {
			var apptype;
			if (type == "android") {
				apptype = 1;
			} else {
				apptype = 2;
			}
			this.$http.get('/u/app/app/apk/update', {
				type: apptype
			}).then(res => {
				if (res.code == 200) {
					console.log(res.data)
					this.downloadUrl = res.data.downloadUrl;
				}
			});
		},

		// 判断是否在微信中打开
		isWeixin() {
			const ua = window.navigator.userAgent.toLowerCase();
			return ua.match(/MicroMessenger/i) == 'micromessenger';
		},

		getConfig() {
			var that = this
			this.$http.post('/u/app/mp/config', {
				url: window.location.href
			}).then(res => {
				console.log("微信jsd数据" + res.data)
				const result = res.data
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
					appId: result.appId, // 必填，公众号的唯一标识
					timestamp: result.timestamp, // 必填，生成签名的时间戳
					nonceStr: result.nonceStr, // 必填，生成签名的随机串
					signature: result.signature, // 必填，签名
					jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
				})
				wx.ready(() => {
					console.log('配置成功-fail-<')
					that.getReady()
				})
				// 当配置不成功时执行
				wx.error(res => {
					// 输出错误信息
					console.log('-配置不成功-fail-<', res)
					if (res.errMsg && res.errMsg.includes(
						'the permission value isoffline verifying')) {
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
							appId: result.appId, // 必填，公众号的唯一标识
							timestamp: result.timestamp, // 必填，生成签名的时间戳
							nonceStr: result.nonceStr, // 必填，生成签名的随机串
							signature: result.signature, // 必填，签名
							jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
						})

						wx.ready(() => {
							console.log('配置成功2-fail-<')
							that.getReady()
						})
					}
				})
			})
		},

		getReady() {
			let shareUrl = window.location.href
			console.log('分享的链接', shareUrl)
			wx.updateAppMessageShareData({
				title: `下载学小成APP`, // 分享标题
				desc: `学小成，小成长，大收获。`, // 分享描述
				link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: `https://xxc.51xxc.com/app/static/logo2_xxc.png`, // 分享图标
				success: function (res) {
					console.log('-22-分享success-<')
				},
				fail: e => {
					console.log('-22-分享fail-<', e)
				}
			})
			wx.updateTimelineShareData({
				title: `下载学小成APP`, // 分享标题
				desc: `学小成，小成长，大收获。`, // 分享描述
				link: shareUrl,
				imgUrl: `https://xxc.51xxc.com/app/static/logo2_xxc.png`, // 分享图标
				success: function (res) {
					console.log('-33-分享success-<')
				},
				fail: e => {
					console.log('-33-分享fail-<', e)
				}
			})
		},


	}
}
</script>

<style>
.app-download {
	position: relative;
	height: 100vh;
	width: 100%;
	overflow-y: auto;
	/* overflow: hidden; */
}

.app-beijing {
	width: 100%;
	height: auto;
	display: block;
}

.footer-btn {
	position: fixed;
	bottom: 6%;
	left: 0;
	right: 0;
	width: 68%;
	height: 100px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50px;
	font-size: 40px;
	font-weight: 500;
	z-index: 1;
	color: rgb(255, 255, 255);
	background-color: rgb(255, 164, 34);
	font-family: sans-serif;
}

.guide-bg {
	background: #262626;
	position: fixed;
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	z-index: 1500;
	z-index: 2;
	opacity: 0.7;
}

.arrow {
	max-height: 100vh;
	overflow: hidden;
	overflow-y: auto;
}

.arrowImg {
	width: 80%;
	position: absolute;
	top: 20px;
	right: 40px;
	/* margin: 20px 0 0 120px; */
	display: block;
}
</style>